var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.82995 13.2285L4.93828 10.3368C4.61328 10.0118 4.08828 10.0118 3.76328 10.3368C3.43828 10.6618 3.43828 11.1868 3.76328 11.5118L7.24661 14.9952C7.57162 15.3202 8.09661 15.3202 8.42162 14.9952L17.2383 6.17852C17.5633 5.85352 17.5633 5.32852 17.2383 5.00352C16.9133 4.67852 16.3883 4.67852 16.0633 5.00352L7.82995 13.2285Z",
    fill: "#0A78CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.0e2a9617022e52d9139b0d2b9289ba21.svg";
export { ForwardRef as ReactComponent };